/**
 * The Complete step's lines (manual-booking-redesign D9, web-studio-sites D12): which form this is,
 * whether it is the booking's last, whether the payment follows it, and the words for a step that
 * could not be read. Shared by the app's step (CompleteStepScreen, which the standard website draws
 * too) and the custom site's `complete-step` piece, so the rules stay in one place.
 */
import type { WaitingOutstanding } from '@/types/dashboard';
import { formTypeLine } from '../DetailsPage/formHeader';
import type { CompleteStep } from './useCompleteStep';

export interface CompleteStepLines {
  /** Form 1 of 2 · its name, or the registration's kind line. */
  typeLine: string;
  isLastForm: boolean;
  /** The payment follows the forms directly: only when the studio does not review them first (D17). */
  hasPaymentAhead: boolean;
}

export function completeStepLines(step: CompleteStep, owed: Pick<WaitingOutstanding, 'forms' | 'payment' | 'approval'> | null | undefined): CompleteStepLines {
  return {
    typeLine: step.step === 'form' ? `Form ${step.index + 1} of ${step.total} · ${step.form.title}` : formTypeLine(step.form.formType),
    isLastForm: step.step === 'form' ? step.index === step.total - 1 : (owed?.forms ?? 1) <= 1,
    hasPaymentAhead: !!owed?.payment && !owed.approval,
  };
}

/** A step that could not be read, in the app's words. */
export const STEP_FAILURE = {
  title: 'Something went wrong',
  message: 'We couldn’t load this step. Please try again in a moment.',
} as const;
